exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._3wy2okXgiuDYmz68d3vwPW ._2nOc70AhwoEMmPWFlpFPcJ{max-width:420px}._3wy2okXgiuDYmz68d3vwPW .Jm68W6qax-pc_LEvsSQIp{object-fit:cover;max-width:100%}._3wy2okXgiuDYmz68d3vwPW ._3vcBAdDw3G4QSEh8AHne-W{display:flex;justify-content:space-between}\n", ""]);

// Exports
exports.locals = {
	"Forms": "_3wy2okXgiuDYmz68d3vwPW",
	"demoBox": "_2nOc70AhwoEMmPWFlpFPcJ",
	"imgPreview": "Jm68W6qax-pc_LEvsSQIp",
	"typedInputs": "_3vcBAdDw3G4QSEh8AHne-W"
};